import React from 'react'
import ChangelogInstance from '../ChangelogInstance';

const TwoDotTenDotTwo = () => {
  return (
    <ChangelogInstance version="2.10.2" date="2021-01-01">
      <li>
       Turned off alternative CS:GO inventory endpoint as default. (will be set off for updating users too).
      </li>
    </ChangelogInstance>
  );
}

export default TwoDotTenDotTwo;